document.addEventListener('DOMContentLoaded', function() {
  if (localStorage.getItem('ageConfirmed') === 'true') return;

  const modal = document.createElement('div');
  modal.innerHTML = `
    <div id="ageModal" class="age-modal">
      <div class="age-content">
        <h2>Bekræft din alder</h2>
        <p>Du skal være over 18 år for at handle på denne side.</p>
        <div class="age-buttons">
          <button id="ageYes">Jeg er over 18 år</button>
          <button id="ageNo">Jeg er under 18 år</button>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const yesBtn = document.getElementById('ageYes');
  const noBtn = document.getElementById('ageNo');

  yesBtn.addEventListener('click', () => {
    localStorage.setItem('ageConfirmed', 'true');
    modal.remove();
  });

  noBtn.addEventListener('click', () => {
    window.location.href = 'https://google.com';
  });
});
